import type { AuthUser, DeletionRequestView, DeletionScope } from '@alterium/shared';
import { api } from './client';

export const accountApi = {
  update: (input: { name?: string | null; locale?: string }) =>
    api.patch<AuthUser>('/account', input),

  changePassword: (currentPassword: string, newPassword: string) =>
    api.post('/account/change-password', { currentPassword, newPassword }),

  deletionRequests: () => api.get<DeletionRequestView[]>('/account/deletion-requests'),

  requestDeletion: (scope: DeletionScope, password?: string) =>
    api.post<DeletionRequestView>('/account/delete', {
      scope,
      ...(password ? { password } : {}),
    }),
};
